import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingStatus': false,
  'loadingFile': false,
  'transactionStatus': {},
  'loadingBackupRecords': false,
  'backupRecords': '',
  'loadingSavedRecords': false,
  'savedRecords': 0,
  'listOrigin': 'japan',
  'updatingPrice': false,
  'updateRecords': 0,
};

export const partsCatalog = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_JAPAN_PART_MASTER_REQUEST]: (state, action) => ({
      ...state,
      'loadingFile': true,
      'savedRecords': 0,
    }),
    [ActionTypes.LOAD_JAPAN_PART_MASTER_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFile': false,
    }),
    [ActionTypes.LOAD_JAPAN_PART_MASTER_FAILED]: (state, action) => ({
      ...state,
      'loadingFile': false,
    }),
    [ActionTypes.LOAD_EXTRA_PARTS_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loadingFile': true,
      'savedRecords': 0,
    }),
    [ActionTypes.LOAD_EXTRA_PARTS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loadingFile': false,
    }),
    [ActionTypes.LOAD_EXTRA_PARTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingFile': false,
    }),
    [ActionTypes.GET_TRANSACTION_STATUS_REQUEST]: (state, action) => ({
      ...state,
      'loadingStatus': true,
    }),
    [ActionTypes.GET_TRANSACTION_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'transactionStatus': action.response.data,
    }),
    [ActionTypes.GET_TRANSACTION_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'transactionStatus': {},
    }),
    [ActionTypes.GET_BACKUP_RECORDS_REQUEST]: (state, action) => ({
      ...state,
      'loadingBackupRecords': true,
    }),
    [ActionTypes.GET_BACKUP_RECORDS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingBackupRecords': false,
      'backupRecords': action.response.data,
    }),
    [ActionTypes.GET_BACKUP_RECORDS_FAILED]: (state, action) => ({
      ...state,
      'loadingBackupRecords': false,
      'backupRecords': 0,
    }),
    [ActionTypes.GET_SAVED_RECORDS_REQUEST]: (state, action) => ({
      ...state,
      'loadingSavedRecords': true,
    }),
    [ActionTypes.GET_SAVED_RECORDS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingSavedRecords': false,
      'savedRecords': action.response.data,
    }),
    [ActionTypes.GET_SAVED_RECORDS_FAILED]: (state, action) => ({
      ...state,
      'loadingSavedRecords': false,
      'savedRecords': 0,
    }),
    [ActionTypes.CLEAR_LOADING_STATUS]: (state, action) => ({
      ...state,
      'loadingStatus': false,
      'loadingFile': false,
    }),
    [ActionTypes.SELECT_PARTS_LIST_ORIGIN]: (state, action) => ({
      ...state,
      'listOrigin': action.payload,
    }),
    [ActionTypes.SAVE_PARTS_PRICE_CHANGE]: (state, action) => ({
      ...state,
      'updatingPrice': true,
    }),
    [ActionTypes.SAVE_PARTS_PRICE_FAILED]: (state, action) => ({
      ...state,
      'updatingPrice': false,
    }),
    [ActionTypes.SAVE_PARTS_PRICE_SUCCESS]: (state, action) => ({
      ...state,
      'updatingPrice': false,
    }),
    [ActionTypes.GET_PRICE_CHANGE_STATUS_FAILED]: (state, action) => ({
      ...state,
      'updateRecords': 0,
    }),
    [ActionTypes.GET_PRICE_CHANGE_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      'updateRecords': action.response.data,
    }),
  })(state, action);
};
